import type {
  BillingOverview,
  StartTopUpDto,
  StartUpgradeDto,
} from '@repo/contracts';

import { apiFetch } from '../api/client';

export const billingKeys = {
  all: ['billing'] as const,
  overview: () => [...billingKeys.all, 'overview'] as const,
};

export const fetchBillingOverview = (): Promise<BillingOverview> =>
  apiFetch<BillingOverview>('/canvas/billing/overview');

export const startSubscriptionCheckout = (
  dto: StartUpgradeDto,
): Promise<{ url: string }> =>
  apiFetch<{ url: string }>('/canvas/billing/subscribe', {
    body: JSON.stringify(dto),
    method: 'POST',
  });

export const startCreditCheckout = (
  dto: StartTopUpDto,
): Promise<{ url: string }> =>
  apiFetch<{ url: string }>('/canvas/billing/checkout', {
    body: JSON.stringify(dto),
    method: 'POST',
  });

export const openBillingPortal = (teamId?: string): Promise<{ url: string }> =>
  apiFetch<{ url: string }>('/canvas/billing/portal', {
    body: JSON.stringify({ teamId }),
    method: 'POST',
  });
